var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmbnu31m7a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.388-.489-2.15 5.733v22.928h7.879v4.301h4.301l4.297-4.301h6.447l8.599-8.596V-.489H13.388zm2.864 2.865h23.643V18.14l-5.016 5.017H27l-4.295 4.296v-4.296h-6.452V2.376zm7.882 14.333H27V8.111h-2.866v8.598zm7.88 0h2.865V8.111h-2.865v8.598z",
    fill: "#5A3E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gmbnu31m7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -.008)",
    d: "M0 0h54v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.bfa2db07a82cf37701eeedf7211fa829.svg";
export { ForwardRef as ReactComponent };